import type { ReactNode } from 'react';

export default async function ServerPrivatePage({
  children,
}: {
  children: ReactNode;
}) {
  //   const supabase = createClient();

  //   const { data, error } = await supabase.auth.getUser();
  //   if (error || !data?.user) {
  //     redirect('/login');
  //   }

  return <>{children}</>;
}
